type validatorType = (value: any, allValues?: object) => any | undefined;

export const combineValidators =
  (...validators: validatorType[]) =>
  (value: string): any | undefined => {
    return validators.reduce((error, validator) => error || validator(value), undefined);
  };
